module.exports = __webpack_public_path__ + "img/wxts.17231f88.png";